import { Dropdown } from "react-bootstrap";
import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";

export default class TaskActionsDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: [],
      show: false,
    };
  }
  onOpen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ show: true });
  };
  onFinish = (e) => {
    this.setState({ show: false });
    if (this.props.onFinish) {
      this.props.onFinish(e);
    }
  };

  render() {
    return (
      <>
        <Dropdown>
          <Dropdown.Toggle as={DropdownToggle} id="dropdown-actions">
            <i className="fa icon-lg fa-ellipsis-v pt-1"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <ActionsList
              essence={this.props.essence}
              key={this.props.id}
              id={this.props.id}
              label={this.props.label}
              onFinish={this.onFinish}
            />
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }
}

class ActionsList extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      method: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });
    let method = await this.context.api.qa(`/${this.props.essence}/method`, {
      id: this.props.id,
    });
    this.setState({ pending: false, method });
  };

  ask = async (method) => {
    if (method.actioncode === "drop") {
      this.context
        .ask(
          `Вы действительно хотите выполнить действие "${method.label}" для "${this.props.label}"`,
          "Подтверждение действия",
          "question"
        )
        .then((result) => {
          if (result.value) {
            this.run(method);
          }
        });
    } else {
      if (method.actioncode === "postpone") {
        this.context
          .prompt("На сколько часов отложить задачу?")
          .then((result) => {
            let period = parseInt(result.value);
            if (period) {
              this.run(method, [{ period }]);
            }
          });
      } else {
        this.run(method);
      }
    }
  };

  run = async (method, params = null) => {
    this.setState({ pending: true });
    if (this.props.onPending) this.props.onPending(true);

    let result = await this.context.api.q("/method/run", {
      id: this.props.id,
      method: method.id,
      params,
    });
    if (result !== false) {
      this.context.toast(`Действите "${method.label}" выполнено`, "success");
      this.finish();
    } else {
      this.context.toast(
        `Не удалось выполнить действите "${method.label}"`,
        "error"
      );
      if (this.props.onPending) this.props.onPending(false);
      this.setState({ pending: false });
    }
  };

  finish = () => {
    this.load();
    if (this.props.onFinish) {
      this.props.onFinish();
    }
  };

  render() {
    return (
      <>
        <Blocker on={this.state.pending}>
          {this.state.method.length === 0 ? (
            <div className="p-4">
              <span className="text-center text-muted font-italic">
                Нет доступных действий
              </span>
            </div>
          ) : null}
          {this.state.method.length > 0 ? (
            <div>
              {this.state.method.map((method) => (
                <div
                  key={method.id}
                  onClick={() => this.ask(method)}
                  className="dropdown-item text-center cursor-pointer"
                >
                  {method.label}
                </div>
              ))}
            </div>
          ) : null}
        </Blocker>
      </>
    );
  }
}

const DropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    title="Меню действий"
    ref={ref}
    className={`cursor-pointer text-light text-hover-primary`}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
